import { useEffect } from "react";

export type ToastKind = "correct" | "wrong" | "info" | "error";

export interface ToastData {
  id: number;
  kind: ToastKind;
  text: string;
}

interface Props {
  toasts: ToastData[];
  onDismiss: (id: number) => void;
}

/** 画面下部に重ねて表示する通知 */
export function ToastStack({ toasts, onDismiss }: Props): React.ReactElement {
  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}

function ToastItem({
  toast,
  onDismiss,
}: {
  toast: ToastData;
  onDismiss: (id: number) => void;
}): React.ReactElement {
  useEffect(() => {
    // エラーは読む時間を長めにとる
    const ms = toast.kind === "error" ? 6000 : 4000;
    const timer = setTimeout(() => onDismiss(toast.id), ms);
    return () => clearTimeout(timer);
  }, [toast.id, toast.kind, onDismiss]);

  return (
    <button
      type="button"
      className={`toast toast--${toast.kind}`}
      onClick={() => onDismiss(toast.id)}
      aria-label="通知を閉じる"
    >
      {toast.text}
    </button>
  );
}
